import { render } from "./AiHologramBrain.vue?vue&type=template&id=ebffa606&scoped=true&ts=true"
import script from "./AiHologramBrain.vue?vue&type=script&lang=ts"
export * from "./AiHologramBrain.vue?vue&type=script&lang=ts"

import "./AiHologramBrain.vue?vue&type=style&index=0&id=ebffa606&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebffa606"]])

export default __exports__